export class BundleTileItems {
  public energy: BundleItem;
  public nbn: BundleItem;
  public mobile: BundleItem;
  public modem?: BundleItem;
}

export class BundleItem {
  public displayItems: DisplayItem[];
  public subtotal?: string;
  public theme?: string;
  public themeTint?: string;
}

export class DisplayItem {
  public productName: string;
  public sku?: string;
  public productInfo?: string;
  public itemCount: number;
  public paymentFrequency?: string;
  public paymentPlanPrice?: string;
}
